<script setup lang="ts">
import { VIcons } from '@/shared/ui'
import { useSendReportFile } from '@/features/Cabinet/Report/model/api'
import { useCabinetReports } from '@/pages/object/CabinetReports'

const model = useCabinetReports()
const { send } = useSendReportFile()

/**
 * Отправка запроса
 * @param item
 */
const save = (item: { id: unknown }) => {
  send({ ...model.filter, page: 1, per_page: 99999, send: item.id })
}
</script>

<template>
  <VTooltip :text="$t('itf.send_to_email')" location="top" activator="#send-button" />

  <VBtn id="send-button" v-bind="$attrs" color="warning">
    <VIcons type="forward_to_inbox" />
  </VBtn>

  <VMenu activator="#send-button">
    <VList density="comfortable" @click:select="save">
      <VListItem value="xlsx">XLSX</VListItem>
      <VListItem value="csv">CSV</VListItem>
      <VListItem value="pdf">PDF</VListItem>
    </VList>
  </VMenu>
</template>
